const locale = {
  // Page title and description
  CHANGELOG: 'Änderungsprotokoll',
  CHANGELOGDESCRIPTION: 'Versionshistorie und Versionshinweise',

  // Section labels
  SECTION_NEW: '✨ Neu',
  SECTION_CHANGED: '🔧 Geändert / Verbessert',
  SECTION_FIXED: '🐛 Behoben',
  SECTION_BREAKING: '💥 Breaking',
  SECTION_DEPRECATED: '⚠️ Veraltet',
  SECTION_SECURITY: '🔒 Sicherheit',
  SECTION_PERFORMANCE: '📈 Performance',
  SECTION_INFRASTRUCTURE: '🧱 Infrastruktur',
  SECTION_DOCS: '📚 Dokumentation',

  // Product labels
  PRODUCT_BUSINESSSUITE: 'Business Suite',
  PRODUCT_TIMELITE: 'TimeLite',
  PRODUCT_EXKURSIO: 'Exkursio',

  // Search
  SEARCH: 'Suchen',
};

export default locale;

